import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { ChatAssistant } from "./ChatAssistant";
import { CONTACT } from "../../data/site";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-void">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ChatAssistant />
      <a
        href={CONTACT.whatsappHref}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-amber text-void shadow-lg transition-transform hover:scale-110 hover:bg-amber-glow"
      >
        <MessageCircle size={26} />
      </a>
    </div>
  );
};
